import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledBanner = styled.div`
  background-color: ${tvar('colors.brand.secondary')};
  color: #fff;
  margin-bottom: ${tvar('space.x3')};

  a {
    color: #fff;

    &:hover {
      color: #ddd;
    }
  }

  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 200;
    margin: 0;
    background-color: ${tvar('colors.brand.primary')};
  }
`;

export const StyledBannerContent = styled.div`
  text-align: center;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${tvar('space.x2')} ${tvar('space.x3')};
`;
